// NPM
import PropTypes from 'prop-types';
import { matchPath, withRouter } from 'react-router-dom';
// Components and utils
import axios from 'components/axios/AxiosFactory';

export function LeadBankCodeComponent({ children, history, location }) {
  const match = matchPath(location.pathname, {
    path: '/cbe/:leadBankCode',
    exact: true,
    strict: false
  });

  if (match) {
    axios.setLeadBankCode(match.params.leadBankCode);
    history.push('/');
    return null;
  }

  return children;
}

LeadBankCodeComponent.propTypes = {
  location: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired
};

export default withRouter(LeadBankCodeComponent);
